import http from '@/lib/http';
import { cmsAiImagesTransformPath } from '@/lib/routes';

export type AiImageTransformOperation = 'upscale' | 'remove-bg';

export async function transformImage(
  url: string,
  operation: AiImageTransformOperation,
): Promise<string> {
  const response = await http.post<{ imageUrl: string }>(cmsAiImagesTransformPath(), {
    url,
    operation,
  });
  const imageUrl = response.data.imageUrl;
  if (!imageUrl) throw new Error('No image URL returned');
  return imageUrl;
}
